export * from './legal-notice-detail.component';
export * from './legal-notice.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal-notice/index.ts